import ParameterErrors from '../errors/ParameterErrors';
import RemoteFileHelper from '../core/RemoteFileHelper';
import UrlHelper from '../core/UrlHelper';
import GroupedCallbacks from '../core/GroupedCallbacks';
import Configuration from '../configuration/Configuration';
import Configurations from '../configuration/Configurations';
import SiteJson from '../site/SiteJson';
import FiltersSettings from '../filters/FiltersSettings';
import LatestSiteInfo from '../site/LatestSiteInfo';
import Urls from '../urls/Urls';
import configurationJson from '../site_specific/current/configuration.json';
import configurationsJson from '../site_specific/configurations.json';
import QuadrantsV3 from '../modelling/quadrants/v3/QuadrantsV3';
const {throwNotProvided}=ParameterErrors;
export default class AssetsManager{
	static get configuration(){
		if(AssetsManager._configuration===undefined){
			AssetsManager._configuration = Configuration.fromJSON(configurationJson);
		}
		return AssetsManager._configuration;
	}
	static get configurations(){
		if(AssetsManager._configurations===undefined){
			AssetsManager._configurations = Configurations.fromJSON(configurationsJson, this.configuration);
		}
		return AssetsManager._configurations;
	}
	static loadConfiguration(){
		return fetch('./configuration.json')
		.then((response) => response.json())
		.then((json) =>  {
			AssetsManager._configuration = Configuration.fromJSON(json);
		})
		.catch(console.error);
	}
	static getSiteAssets(configuration){
		return new Promise((resolve, reject)=>{
			const siteSlug = configuration.siteSlug;
			const siteAssets = AssetsManager._mapSiteSlugToSiteAssets.get(siteSlug);
			if(siteAssets)
			{
				resolve(siteAssets);
				return;
			}

			let groupedCallbackGetSiteAssets = AssetsManager._mapSiteSlugToGroupedCallbackGetSiteAssets.get(siteSlug);
			if(groupedCallbackGetSiteAssets){
				groupedCallbackGetSiteAssets.then(resolve).catch(reject);
				return;
			}
			groupedCallbackGetSiteAssets = new GroupedCallbacks();
			AssetsManager._mapSiteSlugToGroupedCallbackGetSiteAssets.set(siteSlug, groupedCallbackGetSiteAssets);
			const deleteGroupedCallbackFromMap = ()=> AssetsManager._mapSiteSlugToGroupedCallbackGetSiteAssets.delete(siteSlug);
			groupedCallbackGetSiteAssets.then((siteAssets)=>{
				deleteGroupedCallbackFromMap();
				AssetsManager._mapSiteSlugToSiteAssets.set(siteSlug, siteAssets);
				resolve(siteAssets);
			}).catch((err)=>{
				deleteGroupedCallbackFromMap();
				reject(err);
			});
			AssetsManager._getSiteAssets(configuration)
				.then((siteAssets)=>{
					groupedCallbackGetSiteAssets.doThen(siteAssets);
				})
				.catch(groupedCallbackGetSiteAssets.doCatch);
		});
	}	
	
	static _getSiteAssets(configuration){
		return new Promise((resolve, reject)=>{
			let nJsonFilesGot = 0;
			let siteJson = null, latestSiteInfo = null;
			let done = false;
			const gotAJsonFileOrError=(err)=>{
				if(err){
					done = true;
					reject(err);
					return;
				}
				if(done)return;
				nJsonFilesGot++;
				if(nJsonFilesGot<2)return;
				done = true;
				if(latestSiteInfo!==null)
					AssetsManager._updateSiteJsonFromLatestSiteInfo(siteJson, latestSiteInfo);
				resolve({siteJson:siteJson, configuration:configuration});
			};
			AssetsManager._getSiteJsonForSite(configuration)
			.then((siteJsonIn)=>{
				siteJson = siteJsonIn;
				gotAJsonFileOrError();
			}).catch(gotAJsonFileOrError);
			AssetsManager.getLatestSiteInfo(configuration).then((latestSiteInfoIn)=>{
				latestSiteInfo=latestSiteInfoIn;
				gotAJsonFileOrError();
			}).catch(gotAJsonFileOrError);
		});
	}	
	static getQuadrants(url){
		return new Promise((resolve, reject)=>{
			RemoteFileHelper.loadJSON(url).then((jObject)=>{
				const quadrants= 
					QuadrantsV3.fromJSON(jObject)
				resolve(quadrants);
			}).catch(reject);
		});
	}
	static _updateSiteJsonFromLatestSiteInfo(siteJson, latestSiteInfo){
		const configurators = latestSiteInfo.configurators;
		configurators.forEach(configurator=>{
			const houseType = siteJson.houseTypes.getBySlug(configurator.houseTypeSlug);
			if(!houseType)return;
			console.log('CONFIGURAOTR');
			console.log(configurator);
			houseType.configuratorUrl = configurator.configuratorUrl;
			houseType.tourUrl = configurator.tourUrl;
			houseType.videoUrl = configurator.videoUrl;
			houseType.galleryUrl = configurator.galleryUrl;
			houseType.chooseYourStyleVideoUrl = configurator.chooseYourStyleVideoUrl;
			houseType.chooseYourStyleIframeUrl = configurator.chooseYourStyleIframeUrl;
			houseType.floorPlansIframeUrl=configurator.floorPlansIframeUrl;
		});
		const latestPlotInfos = latestSiteInfo.latestPlotInfos;
		const mapPlotNumberToPlot = {};
		siteJson.getPlotsArray().forEach(plot=>mapPlotNumberToPlot[plot.number]=plot);
		latestPlotInfos.forEach(latestPlotInfo=>{
			const plot = mapPlotNumberToPlot[latestPlotInfo.number];
			if(!plot)return;
			plot.price = latestPlotInfo.price;
			plot.status = latestPlotInfo.plotStatusId;
			plot.endOfPriceTextSnippet = latestPlotInfo.endOfPriceTextSnippet;
			plot.abovePriceHtml = latestPlotInfo.abovePriceHtml;
			const newFeatures = latestPlotInfo.featuresForPlot;
			if(newFeatures){
				plot.plotFeatures = newFeatures.map(featureForPlot=>featureForPlot.feature);
			}
		});
		const houseTypes = siteJson.houseTypes;
		const latestHouseTypeInfos = latestSiteInfo.latestHouseTypeInfos;
		latestHouseTypeInfos.forEach(latestHouseTypeInfo=>{
			const houseType = houseTypes.getBySlug(latestHouseTypeInfo.slug);
			if(!houseType)return;
			const newFeatures = latestHouseTypeInfo.featuresForHouseType;
			if(newFeatures)
				houseType.features = newFeatures.filter(featureForHouseType=>featureForHouseType.feature?true:false).map(featureForHouseType=>featureForHouseType.feature);
			houseType.brochureEnabled = latestHouseTypeInfo.brochureEnabled;
			houseType.nBedrooms = latestHouseTypeInfo.nBedrooms;
			houseType.offers = latestHouseTypeInfo.offers;
			houseType.sqrft = latestHouseTypeInfo.sqrft;
		});
	}
	static getLatestSiteInfo(siteSlug){
		return new Promise((resolve, reject)=>{
			const  url = Urls.getLatestSiteInfo(siteSlug);
			RemoteFileHelper.loadJSON(url).then((jObject)=>{
				if(jObject.errorMessage||!jObject.latestSiteInfo)
				{
					reject(new Error('Failed to get latestSiteInfo'));
					return;
				}
				resolve(LatestSiteInfo.fromJSON(jObject.latestSiteInfo));
			}).catch(reject);
		});
	}
	static _getSiteJsonForSite(configuration){
		return new Promise((resolve, reject)=>{
			const  url = Urls.getSiteJson(configuration);
			RemoteFileHelper.loadJSON(url).then((jArrayPlots)=>{
				const siteJson = SiteJson.fromJSON(jArrayPlots, configuration);
				resolve(siteJson);
			}).catch(reject);
		});
	}
}
AssetsManager._mapSiteSlugToSiteAssets = new Map();
AssetsManager._mapSiteSlugToGroupedCallbackGetSiteAssets = new Map();